<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2020-09-30 16:51:13
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 09:33:17
-->
<template>
  <div>
    <search-area tabName="商品列表" searchAdd @search="search" @add="add">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="商品名称或id" prop="name" :label-width="105">
          <Input
            v-model="searchParam.name"
            placeholder="请输商品名称或id"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="list"
      :total="total"
      @search="search"
      :pageNum="searchParam.pageNum"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <product-add
      :visible="showAdd"
      @refresh="search"
      @close="close"
      ref="productadd"
    ></product-add>
  </div>
</template>
<script>
import columns from "./column-config";
import ProductAdd from "./components/ProductAdd.vue";
export default {
  data() {
    return {
      columns: columns(this),
      list: [],
      total: 0,
      editInfo: {},
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        name: "",
      },
      showAdd: false,
    };
  },
  components: {
    ProductAdd,
  },
  created() {
    this.getProductList();
  },
  methods: {
    search(index) {
      this.searchParam.pageNum = index || 1;
      this.searchParam.currentPage = index || 1;
      this.getProductList();
    },
    close() {
      this.showAdd = false;
    },
    // 执行搜索
    async getProductList() {
      let { list, total } = await this.$post(
        "/product/listByPage",
        this.searchParam
      );
      this.list = list;
      this.total = total;
    },
    add() {
      this.showAdd = true;
      this.$nextTick(() => {
        this.$refs.productadd.newDate = {
          banner: [], //商品图片列表
          cover: "", // 商品主图
          name: "", //商品标题
          content: "", //商品富文本详情
          originalPrice: "", // 原价
          price: "", //现价
          type: "1",
          activityTime: "",
          productType: "1",
        };
        this.$refs.productadd.skuList = [
          {
            categoryName: "",
            price: "",
            originalPrice: "",
            perPrice: "",
          },
        ];
      });
    },
  },
};
</script>
<style lang="sass" scoped></style>
